import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // NOTE: StrictMode intentionally double-invokes effects in development (mount->unmount->mount)
  // to help surface unsafe side effects. That's invisible in production, but in this dev preview
  // it was the main cause of pages "loading twice"/flickering on every navigation — removed so
  // the preview matches what shoppers actually see in production.
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
